import React from 'react';
import style from './_form.scss';
import {Textarea} from 'components/vitrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {Conversations, Requests} from 'api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

class ConversationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      content: '',
      isSubmit: false,
      id: this.props.id
    };

    this.props.validators['formConversation'] = [];
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.state.id) {
      this.setState({
        id: nextProps.id
      });
    }
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formConversation'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {content} = this.state;
      const data = {
        content
      };
      this.setState({isSubmit: true});

      Requests.actions.reply.request({id: this.props.objectId}, {
        data: {
          message: this.state.content
        }
      }).then(response => {
        this.props.dispatch({
          type: 'NEW_MESSAGE',
          message: response.data
        });

        this.setState({
          content: ''
        })
      }).finally(() => {
        this.setState({isSubmit: false});
      });
    }
  }

  render() {
    const {image, content, isSubmit, categories} = this.state;
    return (
      <div className="row">
        <form method="POST" onSubmit={this.onSubmit} noValidate>
          <div className="user-form-wrap">
            <div className="box-wrap box-padding-20">
              <div className="complaint-content-wrap">
                <p className="box-header">Nội dung</p>
                <p className="form-warning">
                  <i className="fa fa-exclamation-circle"></i>
                  Giới hạn trong 300 kí tự.
                </p>
              </div>
              <Textarea type="text" placeholder="Nội dung tin nhắn..."
                className="contact-form-group"
                inputClassName="complaint-content"
                required={true}
                rows={3}
                maxLength={300}
                name="content"
                value={content}
                onChange={this.onChange}
                bindValidator={this} channel="formConversation"
              errorMessage="Bạn vui lòng nhập mô tả ngắn"/>
            </div>
          </div>
          <div className="select-category-wrap">
            <div className="box-wrap box-padding-20">
              <p className="box-header">Gửi tin nhắn</p>
              <LaddaButton className="update-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi đi</LaddaButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ConversationForm.defaultProps = {
  validators: {}
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(mapStateToProps)(ConversationForm));



// WEBPACK FOOTER //
// ./components/conversations/Form.jsx